<template>
  <div>
    <div class="ls_drawer_main_content">
      <Form ref="formData" :model="formData" :rules="rules">
        <!-- NAME -->
        <FormItem prop="name" :label="schema.name.label">
          <Input v-model="formData.name" :placeholder="schema.name.label" />
        </FormItem>

        <!-- BALANCE -->
        <FormItem prop="balance" :label="schema.balance.label">
          <InputNumber
            :min="0"
            v-model="formData.balance"
            :placeholder="schema.balance.label"
            style="width: 100%"
          ></InputNumber>
        </FormItem>

        <!-- ACCOUNT TYPE -->
        <FormItem
          prop="type"
          :label="schema.type.label"
          label-position="top"
          v-if="allowedAccTypes.indexOf(formData.type) !== -1"
        >
          <Select v-model="formData.type" filterable>
            <Option
              v-for="item in schema.type.choices"
              :value="item.value"
              :key="item.value"
              >{{ item.display_name }}</Option
            >
          </Select>
        </FormItem>

        <!-- INCLUDE IN COMMON BALANCE -->
        <FormItem
          prop="include_in_balance"
          :label="schema.include_in_balance.label"
        >
          <i-switch v-model="formData.include_in_balance"></i-switch>
        </FormItem>

        <!-- USE TERMINAL -->
        <FormItem
          v-show="formData.type === TYPE_CURRENT_ACC"
          prop="use_terminal"
          :label="schema.use_terminal.label"
        >
          <i-switch v-model="formData.use_terminal"></i-switch>
        </FormItem>

        <Divider v-show="formData.type === TYPE_CURRENT_ACC"
          >Банковские реквизиты</Divider
        >

        <!-- ACCOUNT NUMBER -->
        <FormItem
          v-show="formData.type === TYPE_CURRENT_ACC"
          prop="account_number"
          :label="schema.account_number.label"
        >
          <Input
            v-model="formData.account_number"
            :placeholder="schema.account_number.label"
          />
        </FormItem>
      </Form>
    </div>

    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" @click="cancelAction()">Отмена</Button>
      <Button
        type="primary"
        @click="saveAction()"
        :disabled="disabledSaveButton"
        >Сохранить
      </Button>
    </div>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
// import { base_url } from "../../http.js";
import { BaseFormData } from "../../base/base_form_v2.js";

let _app = BaseFormData();

_app.data = function() {
  return {
    loading: true,
    baseRules: {},
    excludeFieldsRules: [],
    validForm: false,
    isChanged: false,

    TYPE_CURRENT_ACC: 'CURRENT',

    formData: {
      type: "",
      name: "",
      balance: 0,
      include_in_balance: "",
      use_terminal: "",
      account_number: ""
    },

    formDefaultInitData: {
      type: 'CURRENT',
      name: "",
      balance: 0,
      include_in_balance: "false",
      use_terminal: "false",
      account_number: ""
    },

    formSelectOptions: {
      // type: []
    },
  };
};

_app.computed.allowedAccTypes = function() {
  let allowed_types = [];
  for (let el of this.schema.type.choices) {
    allowed_types.push(el.value);
  }
  return allowed_types;
};

export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/account/accountForm.vue